import DYDialog from '@/components/DYDialog'
import DYMainContainer from '@/components/DYMainContainer'
import DYOrgManagement from '@/components/DYOrgManagement'
import DYFileUpload from '@/components/DYFileUpload'
import DYQuillEditor from '@/components/DYQuillEditor'
import DYImageUpload from '@/components/DYImageUpload'
import DYContentHeader from '@/components/DYContentHeader'
import DYLatLonSelectDialog from '@/components/DYLngLatSelectDialog'
import DYPOISearch from '@/components/DYPOISearch'
import DYProvinceCascader from '@/components/DYProvinceCascader'
import DYTreeIcon from '@/components/DYTreeIcon'
import DYInput from '@/components/DYInput'
import DYTreeSelect from '@/components/DYTreeSelect'
import DYOrgTree from '@/components/DYOrgTree'
import DYDrawer from '@/components/DYDrawer'
import DYSelectCustomerDialog from '@/components/DYSelectCustomerDialog'
import DYSelectHouseDialog from '@/components/DYSelectHouseDialog'
import DYSelectCustomerInput from '@/components/DYSelectCustomerInput'
import DYSelectAccountDialog from '@/components/DYSelectAccountDialog'
import DYSelectConductDialog from '@/components/DYSelectConductDialog'
import DYSelectCarportDialog from '@/components/DYSelectCarportDialog'
import DYSelectStaffDialog from '@/components/DYSelectStaffDialog'
import DYImage from '@/components/DYImage'
import DYQrCode from '@/components/DYQrCode'
import DYCommonSearchSelect from '@/components/DYCommonSearchSelect'
import DYRichLocalEditor from '@/components/DYRichLocalEditor'

const componentRegister = function(app) {
// 注册全局容器
  app.component('DyDialog', DYDialog)
  app.component('DyMainContainer', DYMainContainer)
  app.component('DyOrgManagement', DYOrgManagement)
  app.component('DyFileUpload', DYFileUpload)
  app.component('DyImageUpload', DYImageUpload)
  app.component('DyContentHeader', DYContentHeader)
  app.component('DyLatLonSelectDialog', DYLatLonSelectDialog)
  app.component('DyPoiSearch', DYPOISearch)
  app.component('DYQuillEditor', DYQuillEditor)
  app.component('DyProvinceCascader', DYProvinceCascader)
  app.component('DyTreeIcon', DYTreeIcon)
  app.component('DyInput', DYInput)
  app.component('DyTreeSelect', DYTreeSelect)
  app.component('DyOrgTree', DYOrgTree)
  app.component('DyDrawer', DYDrawer)
  app.component('DySelectCustomerDialog', DYSelectCustomerDialog)
  app.component('DySelectHouseDialog', DYSelectHouseDialog)
  app.component('DySelectAccountDialog', DYSelectAccountDialog)
  app.component('DySelectConductDialog', DYSelectConductDialog)
  app.component('DySelectCarportDialog', DYSelectCarportDialog)
  app.component('DYSelectCustomerInput', DYSelectCustomerInput)
  app.component('DYSelectStaffDialog', DYSelectStaffDialog)
  app.component('DyImage', DYImage)
  app.component('DyQrcode', DYQrCode)
  app.component('DyCommonSearchSelect', DYCommonSearchSelect)
  app.component('DyRichLocalEditor', DYRichLocalEditor)
}

export default componentRegister
